import React from 'react';
import { Menu, MenuButton, MenuList, MenuItem, Box, Flex, HStack, IconButton, MenuDivider, Image, Link, Spacer, Center, } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import SignedInContent from '../SignedInContent';
import SignedOutContent from '../SignedOutContent';
import PlatformAdminContent from '../PlatformAdminContent';
import navigator from '../../../services/ui/navigator';
import { logout, notifySessionUserChanged } from '../../../services/auth';
import HeaderProfileIcon from '../../icons/HeaderProfileIcon';
import HeaderRheIcon from '../../icons/HeaderRheIcon';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import { localise } from '../../../services/lang/lang';
const Header = ({ logoLink = '/', isViewOnly = false }) => {
    const history = useHistory();
    const tokens = useTokens();
    const onLogoutClick = async () => {
        await logout();
        notifySessionUserChanged(null);
        history.push('/');
    };
    const boxShadow = '0px 2px 5px 0px rgba(0,0,0,0.25)';
    const styles = {
        outerContainer: {
            background: 'white',
            position: 'fixed',
            zIndex: '10000',
            width: '100%',
            height: '52px',
            padding: '0 10px 0 5px',
            'box-shadow': boxShadow,
            '-webkit-box-shadow': boxShadow,
            '-moz-box-shadow': boxShadow,
        },
        innerContainer: {
            justifyContent: 'space-between',
            alignItems: 'center',
            h: '48px',
        },
    };
    return (React.createElement(Box, { as: "header", "data-testid": "header", sx: styles.outerContainer },
        React.createElement(Flex, { sx: styles.innerContainer },
            React.createElement(HStack, { w: "300px" },
                React.createElement(Link, { href: logoLink, "aria-label": "The Housing App" },
                    React.createElement(Image, { ml: tokens.Spacing02, mt: tokens.Spacing02, h: "32px", w: "230px", objectFit: "scale-down", alt: "The Housing App", src: "/images/THA_logo.png" }))),
            React.createElement(RenderIf, { condition: !isViewOnly },
                React.createElement(Box, { "data-testid": "none_view_only_content" },
                    React.createElement(SignedInContent, null,
                        React.createElement(HStack, { "data-testid": "signed-in-content", spacing: "8px", tabIndex: 0 },
                            React.createElement(Menu, { variant: "menu" },
                                React.createElement(MenuButton, { as: IconButton, "aria-label": "Profile actions", icon: React.createElement(HeaderProfileIcon, null), variant: "solid", colorScheme: "white" }),
                                React.createElement(MenuList, null,
                                    React.createElement(PlatformAdminContent, null,
                                        React.createElement(Link, { "data-testid": "platform_admin_content", href: "/platform-admin", variant: "no-underline" },
                                            React.createElement(MenuItem, null, localise('PLATFORM_ADMIN')))),
                                    React.createElement(Link, { href: "/inspections", variant: "no-underline" },
                                        React.createElement(MenuItem, null, localise('DASHBOARD'))),
                                    React.createElement(MenuDivider, null),
                                    React.createElement(Link, { href: window.config.contact_sales_form_link, isExternal: true, variant: "no-underline" },
                                        React.createElement(MenuItem, null, localise('SUPPORT'))),
                                    React.createElement(Link, { href: window.config.tos_licence_link, isExternal: true, variant: "no-underline" },
                                        React.createElement(MenuItem, null, localise('TERMS_AND_CONDITIONS'))),
                                    React.createElement(MenuDivider, null),
                                    React.createElement(Link, { href: "/settings/organisation-profile/general", variant: "no-underline" },
                                        React.createElement(MenuItem, null, localise('SETTINGS'))),
                                    React.createElement(Link, { href: "#", variant: "no-underline", onClick: onLogoutClick },
                                        React.createElement(MenuItem, null, localise('SIGN_OUT'))))),
                            React.createElement(HeaderRheIcon, null))),
                    React.createElement(SignedOutContent, null,
                        React.createElement(Flex, { "data-testid": "signed-out-content", justify: "space-between", w: "100%", h: "52px" },
                            React.createElement(Spacer, null),
                            React.createElement(Center, null,
                                React.createElement(Link, { onClick: () => navigator.push('/sign-in'), variant: "no-underline" }, localise('SIGN_IN'))))))))));
};
export default Header;
